module.exports = __webpack_public_path__ + "img/new_08.1851ac67.jpg";